import Model from './utils/model'
import nexus from '@db2b/nexus-js'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Contact'
    },
    name: 'contact',
    url: nexus.url('crm2', 'contacts')
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/contact.js